import { LANGUAGES } from '@shared/utils'
import { useFormContext } from 'react-hook-form'
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form'
import 'react-phone-number-input/style.css'
import flags from 'react-phone-number-input/flags'
import './phone-input-styles.css'

export const InputPhone = ({
  className,
  value,
  name,
  defaultCountry = LANGUAGES.es.toUpperCase(),
  setIsChanged,
}) => {
  const { control } = useFormContext()

  const handleChange = (newValue) => {
    if (newValue !== value) {
      if (setIsChanged) {
        setIsChanged(true)
      }

      // Save phone to localStorage for no-digital appointments when it changes
      if (name === 'phone' && newValue) {
        // Ensure the phone number has the +34 prefix for Spain
        let formattedPhone = newValue

        // If the phone doesn't start with +, add the country code
        if (!formattedPhone.startsWith('+')) {
          formattedPhone = `+${formattedPhone}`
        }

        // If it doesn't have the +34 prefix, add it
        if (!formattedPhone.startsWith('+34')) {
          formattedPhone = `+34${formattedPhone.replace(/^\+/, '')}`
        }

        // Remove any spaces and ensure proper format
        formattedPhone = formattedPhone.replace(/\s/g, '')

        console.log('📱 Saving phone to localStorage:', formattedPhone)
        localStorage.setItem('noDigitalPhone', formattedPhone)
      }
    }
  }

  const handleBlur = (e) => {
    // Additional validation on blur
    if (name === 'phone') {
      const currentValue = e.target.value || value
      if (currentValue) {
        let formattedPhone = currentValue

        // Ensure the phone number has the +34 prefix for Spain
        if (!formattedPhone.startsWith('+')) {
          formattedPhone = `+${formattedPhone}`
        }

        // If it doesn't have the +34 prefix, add it
        if (!formattedPhone.startsWith('+34')) {
          formattedPhone = `+34${formattedPhone.replace(/^\+/, '')}`
        }

        // Remove any spaces and ensure proper format
        formattedPhone = formattedPhone.replace(/\s/g, '')

        console.log('📱 Final phone format on blur:', formattedPhone)
        localStorage.setItem('noDigitalPhone', formattedPhone)
      }
    }
  }

  return (
    <PhoneInputWithCountry
      className={className}
      defaultValue={value}
      // For prevent app error
      onFocus={() => {}}
      onBlur={handleBlur}
      country={defaultCountry}
      defaultCountry={defaultCountry}
      countries={[defaultCountry]}
      international={true}
      flags={flags}
      name={name}
      control={control}
      onChange={handleChange}
    />
  )
}
